export default __webpack_public_path__ + "static/media/supplier_img_about.cd6654ad.gif";